import {Route} from "../../registry/routes.js"
import Jobs from "../../components/jobs/Jobs.vue";
import JobDetails from "../../components/jobs/JobDetails.vue"

const jdroute = new Route("job-details", ":jobId", {"job-details":JobDetails}, {componentType:"job_modal_component",title:"Jobs"}, [], true, (to, from, next)=>{document.title=`${to.params.job_name?to.params.job_name+' | ':''}${document.title}`;next();})
const r = new Route("jobs", "jobs", {"jobs":Jobs}, {componentType:"modal_component", title:"Jobs"}, [jdroute], true, null)

export default r